import { useQuery } from "@apollo/client";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import moment from "moment";
import { useEffect, useState } from "react";
import "../../App.css";
import { currencyFormat } from "../../Function/DynamicFn";
import { GET_DAILY_UNIFORM_REPORT } from "../../Schema/Report";
import { EmptyTr } from "../Include/EmptyData";
import { LoadingTr } from "../Include/LoadingPage";

export default function ReportUniformTakeOut({
  endDate,
  startDate,
  warehouseValId,
  materialListId,
  unitIds,
  studentId,
}) {
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalQty, setTotalQty] = useState(0);

  useQuery(GET_DAILY_UNIFORM_REPORT, {
    variables: {
      to: endDate ? dayjs(endDate).format("YYYY-MM-DD") : null,
      from: startDate ? dayjs(startDate).format("YYYY-MM-DD") : null,
      studentId: studentId ? studentId : null,
      warehouseIds: warehouseValId ? [warehouseValId] : [],
      materialIds: materialListId ? materialListId : [],
      unitIds: unitIds ? unitIds : [],
      academicYearIds: [],
      classIds: [],
      gradeIds: [],
    },
    onCompleted: ({ getProvideMaterialForStudentReport }) => {
      // console.log(
      //   "getProvideMaterialForStudentReport:::",
      //   getProvideMaterialForStudentReport,
      // );
      setTableData(getProvideMaterialForStudentReport);
      if (getProvideMaterialForStudentReport.length > 0) {
        const totals = getProvideMaterialForStudentReport.reduce(
          (acc, pre) => {
            acc.totalSell += pre.sellQty;
            acc.totalGive += pre.qty;
            acc.total += pre.sellQty + pre.qty;
            return acc;
          },
          {
            totalSell: 0,
            totalGive: 0,
            total: 0,
          },
        );

        setTotalQty({
          totalSell: totals.totalSell?.toFixed(2),
          totalGive: totals.totalGive?.toFixed(2),
          total: totals.total?.toFixed(2),
        });
      } else setTotalQty(null);
      setLoading(false);
    },
    onError: (err) => {
      console.log("Error::", err?.message);
    },
  });

  useEffect(() => {
    setLoading(true);
  }, [
    endDate,
    startDate,
    warehouseValId,
    materialListId,
    studentId,
    unitIds,
    endDate,
    startDate,
  ]);

  return (
    <>
      <Stack
        direction="column"
        justifyContent="center"
        alignItems="center"
        marginTop="25px"
      >
        <Typography className="report-title-kh">
          តារាងតាមដានសិស្សដកសម្ភារៈ
        </Typography>
        <Typography className="report-title-en">
          {`${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")}`}
        </Typography>
      </Stack>

      <div className="report-table-scroll-container">
        <table className="report-table">
          <tbody className="report-table-thead">
            <tr>
              <td className="report-table-th-sticky" align="center" width="2%">
                ល.រ
              </td>
              <td className="report-table-th-sticky" align="center" width="15%">
                ឈ្មោះសិស្ស (ខ្មែរ)
              </td>
              <td className="report-table-th-sticky" align="center" width="15%">
                ឈ្មោះសិស្ស (អង់គ្លេស)
              </td>
              <td className="report-table-th-sticky" align="center">
                បរិយាយ
              </td>
              <td className="report-table-th-sticky" align="center" width="5%">
                ខ្នាត
              </td>
              <td className="report-table-th-sticky" align="center" width="8%">
                ចំនួនផ្តល់
              </td>
              <td className="report-table-th-sticky" align="center" width="8%">
                ចំនួនលក់
              </td>
              <td className="report-table-th-sticky" align="center" width="8%">
                សរុប
              </td>
            </tr>
          </tbody>
          {loading ? (
            <LoadingTr colSpan={8} />
          ) : !tableData?.length ? (
            <EmptyTr colSpan={8} />
          ) : (
            <tbody className="report-table-body">
              {tableData?.map((row, index) => {
                return (
                  <tr key={index}>
                    <td className="report-table-body-td-center">{index + 1}</td>

                    <td className="report-table-body-td-left">
                      {row?.studentBookId?.studentId?.lastName +
                        " " +
                        row?.studentBookId?.studentId?.firstName}
                    </td>

                    <td className="report-table-body-td-left">
                      {row?.studentBookId?.studentId?.englishName}
                    </td>

                    <td className="report-table-body-td-left">
                      {row?.listMaterialUnitId?.materialId?.materialKhName}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.listMaterialUnitId?.unitId?.unitKhName}
                    </td>

                    <td className="report-table-body-td-center">{row?.qty}</td>

                    <td className="report-table-body-td-center">
                      {row?.sellQty}
                    </td>

                    <td className="report-table-body-td-center">
                      {row?.qty + row?.sellQty}
                    </td>
                  </tr>
                );
              })}
              <tr>
                <td
                  colSpan={4}
                  className="report-table-tbody-td-total-total"
                ></td>
                <td className="report-table-tbody-td-total-total">សរុប</td>
                <td
                  className="report-table-tbody-td-total-cost"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  {currencyFormat(totalQty?.totalGive) ?? "0.00"}
                </td>
                <td
                  className="report-table-tbody-td-total-cost"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  {currencyFormat(totalQty?.totalSell) ?? "0.00"}
                </td>
                <td
                  className="report-table-tbody-td-total-cost"
                  align="center"
                  style={{ fontWeight: "bold" }}
                >
                  {currencyFormat(totalQty?.total) ?? "0.00"}
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
    </>
  );
}
